import { Globals } from '@react-spring/web'

/** Reduced-motion visitors get instant react-spring animations, kept in
 *  step with the OS setting; framer-motion follows it via MotionConfig. */
export const setupReducedMotion = () => {
  const query = window.matchMedia('(prefers-reduced-motion: reduce)')
  const apply = () => Globals.assign({ skipAnimation: query.matches })
  apply()
  query.addEventListener('change', apply)
}
